import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";

// Public Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import CoursesPage from "./pages/CoursesPage";
import CourseDetailPage from "./pages/CourseDetailPage";
import FacultyPage from "./pages/FacultyPage";
import GalleryPage from "./pages/GalleryPage";
import ContactPage from "./pages/ContactPage";
import ScholarshipPage from "./pages/ScholarshipPage";
import TermsPage from "./pages/TermsPage";
import RefundPage from "./pages/RefundPage";
import PrivacyPage from "./pages/PrivacyPage";

// Auth Pages
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";

// Student Dashboard
import StudentDashboard from "./pages/dashboard/StudentDashboard";
import StudentCourses from "./pages/dashboard/StudentCourses";
import StudentSyllabus from "./pages/dashboard/StudentSyllabus";
import StudentMaterials from "./pages/dashboard/StudentMaterials";
import StudentTests from "./pages/dashboard/StudentTests";
import StudentResults from "./pages/dashboard/StudentResults";
import StudentNotices from "./pages/dashboard/StudentNotices";
import StudentReferrals from "./pages/dashboard/StudentReferrals";
import StudentSupport from "./pages/dashboard/StudentSupport";
import StudentProfile from "./pages/dashboard/StudentProfile";

// Admin Dashboard
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminCourses from "./pages/admin/AdminCourses";
import AdminFaculty from "./pages/admin/AdminFaculty";
import AdminStudents from "./pages/admin/AdminStudents";
import AdminEnrollments from "./pages/admin/AdminEnrollments";
import AdminScholarships from "./pages/admin/AdminScholarships";
import AdminNotices from "./pages/admin/AdminNotices";
import AdminGallery from "./pages/admin/AdminGallery";
import AdminFAQs from "./pages/admin/AdminFAQs";
import AdminCenters from "./pages/admin/AdminCenters";
import AdminToppers from "./pages/admin/AdminToppers";
import AdminInquiries from "./pages/admin/AdminInquiries";
import AdminTickets from "./pages/admin/AdminTickets";
import AdminTestimonials from "./pages/admin/AdminTestimonials";
import AdminDirectors from "./pages/admin/AdminDirectors";

// Faculty Portal
import FacultyDashboard from "./pages/faculty/FacultyDashboard";
import FacultyCourses from "./pages/faculty/FacultyCourses";
import FacultySyllabus from "./pages/faculty/FacultySyllabus";
import FacultyMaterials from "./pages/faculty/FacultyMaterials";
import FacultyProfile from "./pages/faculty/FacultyProfile";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/courses" element={<CoursesPage />} />
          <Route path="/courses/:courseId" element={<CourseDetailPage />} />
          <Route path="/faculty" element={<FacultyPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/scholarship" element={<ScholarshipPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/refund" element={<RefundPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />

          {/* Auth Routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Student Dashboard Routes */}
          <Route path="/dashboard" element={<StudentDashboard />} />
          <Route path="/dashboard/courses" element={<StudentCourses />} />
          <Route path="/dashboard/syllabus" element={<StudentSyllabus />} />
          <Route path="/dashboard/materials" element={<StudentMaterials />} />
          <Route path="/dashboard/tests" element={<StudentTests />} />
          <Route path="/dashboard/results" element={<StudentResults />} />
          <Route path="/dashboard/notices" element={<StudentNotices />} />
          <Route path="/dashboard/referrals" element={<StudentReferrals />} />
          <Route path="/dashboard/support" element={<StudentSupport />} />
          <Route path="/dashboard/profile" element={<StudentProfile />} />

          {/* Faculty Portal Routes */}
          <Route path="/faculty-portal" element={<FacultyDashboard />} />
          <Route path="/faculty-portal/courses" element={<FacultyCourses />} />
          <Route path="/faculty-portal/syllabus" element={<FacultySyllabus />} />
          <Route path="/faculty-portal/materials" element={<FacultyMaterials />} />
          <Route path="/faculty-portal/profile" element={<FacultyProfile />} />

          {/* Admin Routes */}
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/courses" element={<AdminCourses />} />
          <Route path="/admin/faculty" element={<AdminFaculty />} />
          <Route path="/admin/students" element={<AdminStudents />} />
          <Route path="/admin/enrollments" element={<AdminEnrollments />} />
          <Route path="/admin/scholarships" element={<AdminScholarships />} />
          <Route path="/admin/notices" element={<AdminNotices />} />
          <Route path="/admin/gallery" element={<AdminGallery />} />
          <Route path="/admin/faqs" element={<AdminFAQs />} />
          <Route path="/admin/centers" element={<AdminCenters />} />
          <Route path="/admin/toppers" element={<AdminToppers />} />
          <Route path="/admin/inquiries" element={<AdminInquiries />} />
          <Route path="/admin/tickets" element={<AdminTickets />} />
          <Route path="/admin/testimonials" element={<AdminTestimonials />} />
          <Route path="/admin/directors" element={<AdminDirectors />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
